<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-user-solid"></i>
                </div>
                <div class="header-text">
                    <h2>角色管理</h2>
                    <p>系统权限分配 · 角色配置管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.roleName" placeholder="搜索角色名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增角色
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        角色列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            可分配权限
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :height="tableHeight" :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="roleId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick"
                        @selection-change="handleSelectionChange">
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_user" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增角色信息" dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val"
            @item-change="handleItemChange">
        </aj-form-add>
        <aj-form-edit ref="edit_user" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑角色信息" labelWidth="100px"
            @confirm="handleEditConfirm">
        </aj-form-edit>
        <aj-form-edit ref="edit_role" :formConfig="formConfig_role" :formData="formRole" :dialogVisible="IsAuth"
            @update:dialogVisible="val => IsAuth = val" dialogTitle="分配权限" labelWidth="100px" @confirm="AuthSureBtn">
            <template #role-slot>
                <el-tree :data="authTreeList" show-checkbox node-key="authId" ref="authTree"
                    :default-checked-keys="defaultChecked" :props="defaultProps" @check-change="handleCheckChange">
                </el-tree>
            </template>
        </aj-form-edit>
        <aj-form-edit ref="edit_userRole" :formConfig="formConfig_userRole" :formData="form_userRole"
            :dialogVisible="Is_userRole" @update:dialogVisible="val => Is_userRole = val" dialogTitle="编辑角色下的用户"
            labelWidth="100px" @confirm="userRoleSureBtn">
            <template #userTable-slot>
                <aj-table ref="aj_user_Table" :data="userTableData" :columns="tableColumns_user"
                    :editable="tableEditable" :use-internal-pagination="false" row-id-key="userRoleId
                    " stripe @operate-btn-click="handleOperateBtnClick">
                </aj-table>
            </template>
        </aj-form-edit>
    </div>
</template>

<script>

import {
    getAjRoleList, addAjRole, updateAjRole, deleteAjRole,
    getAjAuthTree, getAjRoleAuthList, updateAjRoleAuth, getAjUserList,
    getAjRoleUserList, updateAjRoleUserMulti, deleteAjRoleUser,
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            userTableData: [],
            tableColumns_user: [
                { type: 'index', label: '序号', width: 80, fixed: 'left' }, // 序号列
                { label: '用户名称', prop: 'userName', align: 'center', fixed: 'left' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 150,
                    // 操作列默认按钮（可被插槽覆盖）
                    buttons: [
                        { key: 'userDel', text: '删除', icon: 'el-icon-delete', },
                    ]
                }
            ],
            Is_userRole: false,
            getAjUserList_data: [],
            formConfig_userRole: [
                [{
                    type: 'select', label: '用户', prop: 'userIds', placeholder: '请选择', span: 24, required: true,
                    options: this.getAjUserList_data, optionLabelKey: 'auName', optionValueKey: 'auId', filterable: true, multiple: true,
                },],
                [{ type: 'custom', label: '已加用户列表', prop: 'userTable', span: 24, required: false },],

            ],
            form_userRole: {},
            authTreeList: [
                {
                    authId: 1,
                    label: '测试权限1',
                    children: []
                }
            ],
            IsAuth: false,
            formRole: {
                role: [],
            },
            formConfig_role: [
                [{ type: 'custom', label: '权限列表', prop: 'role', placeholder: '请输入角色名称', span: 24, required: false, }]
            ],
            defaultChecked: [],
            authParent: [],
            myAuthList: [],
            myRoleId: '',
            defaultProps: {
                children: 'children',
                label: 'authName'
            },
            addDialogVisible: false,
            editDialogVisible: false,
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left' }, // 序号列
                { label: '角色名称', prop: 'roleName', width: 130, align: 'center', fixed: 'left' },
                { label: '角色描述', prop: 'roleRemark', },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 350,
                    // 操作列默认按钮（可被插槽覆盖）
                    buttons: [
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete', },
                        { key: 'fpqx', text: '分配权限', icon: 'el-icon-warning-outline', },
                        { key: 'user', text: '添加用户', icon: 'el-icon-user', }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                roleName: '',
                currentPage: 1,
                pageSize: 20,
            },
            // 表格高度变量，直接用于 :height
            tableHeight: 400,
        };
    },
    activated() {
      
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.partserch();
        getAjAuthTree().then(res => {
            this.authTreeList = res.data
        });
        getAjUserList().then(res => {
            this.getAjUserList_data = res.data;
        })
       
        
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        /**
         * 窗口大小变化时更新表格高度
         */
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 100 });
                console.log(this.tableHeight);
                
            });
        },
        async userRoleSureBtn() {
            try {
                await this.$confirmDialog({
                    content: '确认添加该用户吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(this.form_userRole));
                newData.userIds = newData.userIds ? JSON.stringify(newData.userIds) : '';
                updateAjRoleUserMulti(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.form_userRole.userIds = [];
                        // this.$refs.edit_userRole.cancelDiaLog();
                        this.theGetAjRoleUserList();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        theGetAjRoleUserList() {
            getAjRoleUserList({ roleId: this.theRoleId }).then(res => {

                this.userTableData = res.data;

            })
        },
        userRoleOpen(row) {
            this.formConfig_userRole = [
                [{
                    type: 'select', label: '用户', prop: 'userIds', placeholder: '请选择', span: 24, required: true,
                    options: this.getAjUserList_data, optionLabelKey: 'auName', optionValueKey: 'auId', filterable: true, multiple: true,
                },],
                [{ type: 'custom', label: '已加用户列表', prop: 'userTable', span: 24, required: false },],
            ];
            this.theRoleId = row.roleId;
            this.theGetAjRoleUserList();
            this.form_userRole = {
                roleId: row.roleId,
                userIds: [],
            };
            this.Is_userRole = true;
        },
        // 表单配置项
        getFormInit() {
            this.formConfig = [
                [{ type: 'input', label: '角色名称', prop: 'roleName', placeholder: '请输入角色名称', span: 24, required: true, },],
                [{ type: 'input', label: '角色描述', prop: 'roleRemark', placeholder: '请输入角色描述', span: 24, required: false },],
            ];
            this.form = {
                roleName: '',
                roleRemark: '',
            };
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该角色吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(data));
                updateAjRole(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            try {
                await this.$confirmDialog({
                    content: '确认新增该角色吗？',
                    type: 'success'
                })
                const newData = JSON.parse(JSON.stringify(data));
                addAjRole(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },

        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },

        // 分页切换回调
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            getAjRoleList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;

            });
        },

        // 操作按钮点击回调（默认按钮）
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'userDel':
                    this.handleUserRoleDelete(row);
                    break;
                case 'user':
                    this.userRoleOpen(row);
                    break;
                case 'fpqx':
                    this.AssignAuth(row);
                    break;
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },
        // 选中状态变化回调
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.id));
        },
        // 查看操作
        handleView(row) {
            this.$message.info(`查看用户：${row.name}，手机号：${row.phone}`);
        },
        // 编辑操作
        handleEdit(row) {
            this.getFormInit();
            const s = JSON.parse(JSON.stringify(row));
            s.auHeader = row.auHeader ? [row.auHeader] : [];
            this.form = s;
            this.editDialogVisible = true;
        },
        async handleUserRoleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该用户吗？',
                    type: 'danger'
                })
                // 确定逻辑
                deleteAjRoleUser({ userRoleId: row.userRoleId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.theGetAjRoleUserList();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该用户吗？',
                    type: 'danger'
                })
                // 确定逻辑
                deleteAjRole({ roleId: row.roleId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        handleCheckChange(data, _checked, _indeterminate) {
            // 根据当前所有选中节点重新计算 authParent
            const checkedNodes = this.$refs.authTree.getCheckedNodes();
            const parentSet = new Set();
            checkedNodes.forEach(node => {
                if (node.authParentId && node.authParentId !== 0) {
                    parentSet.add(node.authParentId);
                }
            });
            this.authParent = Array.from(parentSet);
        },
        AuthHandleClose() {
            this.IsAuth = false;
            this.myAuthList = [];
            this.authParent = [];
            this.defaultChecked = [];
            this.myRoleId = ''

        },
        async AuthSureBtn() {
            try {
                await this.$confirmDialog({
                    content: '确认编辑权限吗？',
                    type: 'danger'
                })
                const ids = this.$refs.authTree.getCheckedKeys().concat(this.authParent)
                updateAjRoleAuth({ roleId: this.formRole.roleId, authListString: JSON.stringify(ids) }).then(res => {
                    if (res.data || res.data == 0) {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                        this.myAuthList = [];
                        this.authParent = [];
                        this.defaultChecked = [];
                        this.$refs.authTree.setCheckedKeys([]);
                        this.$refs.edit_role.cancelDiaLog();
                        this.partserch();
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        AssignAuth(row) {
            this.IsAuth = true;
            this.formRole.roleId = row.roleId
            getAjRoleAuthList({ roleId: row.roleId }).then(res => {
                res.data.forEach((item, index) => {
                    // this.defaultChecked.push(item.authId)
                    if (item.children && item.children.length > 0) {
                        item.children.forEach((itemChildren, id) => {
                            this.defaultChecked.push(itemChildren.authId)
                            this.authParent.push(itemChildren.authParentId)
                        })
                    } else {
                        this.defaultChecked.push(item.authId)
                    }
                })
                const arr = JSON.parse(JSON.stringify(this.defaultChecked))
                this.defaultChecked = arr
                console.log(JSON.parse(JSON.stringify(this.defaultChecked)), this.authParent);
            })

        },

        partserch() {
            this.formDatas.currentPage = 1;
            getAjRoleList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        resetSearch() {
            this.formDatas.roleName = '';
            this.partserch();
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(139, 92, 246, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    /* display: grid; */
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #8b5cf6;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f8fafc;
    border-radius: 20px;
}

/* Search Card */
.search-card {
    grid-column: span 1;
}

.search-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.search-input-wrapper {
    flex: 1;
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #8b5cf6;
    background: white;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>